import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, FormFeedback, Spinner } from 'reactstrap';
import { collection, serverTimestamp, addDoc, updateDoc, doc } from "firebase/firestore";
import { db, addPrefix } from '../firebase';

const BranchModal = ({ open, onClose, branch, branches, loadBranches }) => {
    const [branchName, setBranchName] = useState('');
    const [branchId, setBranchId] = useState('');
    const [status, setStatus] = useState('active');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (branch) {
            setBranchName(branch.name || '');
            setBranchId(branch.customId || '');
            setStatus(branch.status || 'active');
        } else {
            setBranchName('');
            setBranchId('');
            setStatus('active');
        }
        setError('');
        setLoading(false);
    }, [branch, open]);

    const handleSave = async () => {
        if (!branchName || !branchId) {
            setError('Please fill in all required fields.');
            return;
        }
        setLoading(true);
        const branchIdFromHash = window.location.hash.replace('#', '');
        const currentBranch = branches.find(b => b.customId === branchIdFromHash);
        const tenant = currentBranch ? currentBranch.tenant : null;
        if (!tenant) {
            setError('Unable to determine tenant.');
            setLoading(false);
            return;
        }
        try {
            if (branch && branch.id) {
                // Edit mode
                await updateDoc(doc(db, addPrefix("branches"), String(branch.id)), {
                    name: branchName,
                    status: status,
                    customId: branchId,
                    tenant: tenant
                });
            } else {
                // Add mode
                await addDoc(collection(db, addPrefix("branches")), {
                    name: branchName,
                    status: status || "active",
                    dateAdded: serverTimestamp(),
                    customId: branchId,
                    tenant: tenant
                });
            }
            setLoading(false);
            setError('');
            if (typeof loadBranches === 'function') loadBranches();
            onClose();
        } catch (err) {
            setError('Error: Unable to save branch in database!');
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={open} toggle={onClose}>
            <ModalHeader toggle={onClose}>{branch ? 'Edit Branch' : 'Add New Branch'}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="branchName">Branch Name<span style={{ color: 'red' }}>*</span></Label>
                        <Input
                            id="branchName"
                            type="text"
                            value={branchName}
                            onChange={e => setBranchName(e.target.value)}
                            invalid={!!error && !branchName}
                            disabled={loading}
                        />
                        <FormFeedback>Branch Name is required.</FormFeedback>
                    </FormGroup>
                    <br />
                    <FormGroup>
                        <Label for="branchId">Branch ID<span style={{ color: 'red' }}>*</span></Label>
                        <Input
                            id="branchId"
                            type="text"
                            value={branchId}
                            onChange={e => setBranchId(e.target.value)}
                            disabled={!!branch || loading}
                            invalid={!!error && !branchId}
                        />
                        <FormFeedback>Branch ID is required.</FormFeedback>
                    </FormGroup>
                    <br />
                    <FormGroup>
                        <Label for="status">Status</Label>
                        <Input
                            id="status"
                            type="select"
                            value={status}
                            onChange={e => setStatus(e.target.value)}
                            disabled={loading}
                        >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </Input>
                    </FormGroup>
                    {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onClose} disabled={loading}>Cancel</Button>
                <Button color="primary" onClick={handleSave} disabled={loading}>
                    {loading && <Spinner size="sm" className="mr-2" />} {loading ? (branch ? 'Updating...' : 'Adding...') : (branch ? 'Update' : 'Add')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default BranchModal; 